var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M126.612,123.974c14.559,0,27.166-5.222,37.466-15.524c10.301-10.301,15.522-22.904,15.522-37.465 c0-14.556-5.222-27.161-15.524-37.465C153.774,23.222,141.169,18,126.612,18c-14.561,0-27.164,5.222-37.465,15.522 S73.623,56.428,73.623,70.985c0,14.561,5.223,27.166,15.526,37.466C99.451,118.751,112.056,123.974,126.612,123.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M219.328,187.168c-0.297-4.287-0.898-8.963-1.783-13.901c-0.893-4.975-2.043-9.678-3.419-13.976 c-1.422-4.443-3.355-8.83-5.745-13.035c-2.481-4.364-5.395-8.164-8.664-11.291c-3.419-3.271-7.605-5.901-12.446-7.82 c-4.824-1.908-10.17-2.875-15.888-2.875c-2.246,0-4.418,0.921-8.612,3.652c-2.581,1.683-5.601,3.63-8.971,5.784 c-2.882,1.836-6.786,3.557-11.608,5.114c-4.705,1.522-9.482,2.294-14.196,2.294c-4.715,0-9.49-0.772-14.2-2.294 c-4.817-1.556-8.721-3.276-11.6-5.113c-3.338-2.133-6.36-4.08-8.98-5.787c-4.189-2.731-6.363-3.652-8.609-3.652 c-5.72,0-11.064,0.968-15.887,2.879c-4.837,1.915-9.025,4.545-12.447,7.82c-3.268,3.129-6.183,6.927-8.661,11.289 c-2.388,4.205-4.322,8.59-5.745,13.037c-1.375,4.299-2.524,9-3.417,13.975c-0.885,4.931-1.485,9.609-1.783,13.906 c-0.292,4.21-0.44,8.579-0.44,12.991c0,11.484,3.651,20.781,10.85,27.637C54.187,234.568,63.594,238,75.035,238h105.931 c11.44,0,20.845-3.431,27.956-10.198c7.201-6.851,10.851-16.15,10.851-27.639C219.771,195.73,219.622,191.357,219.328,187.168z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.46ffe48d82eabae457e38e0a9bfb523d.svg";
export { ForwardRef as ReactComponent };